<template>
    <modal-content @close="$emit('close')">
        <image-form ref="form" @o3-submit="onSubmit"/>
    </modal-content>
</template>

<script>
import ModalContent from '../../../../../components/Modal/ModalContent';
import ImageForm from './ImageForm';

export default {
    name:       'ImageDialog',
    components: {
        ImageForm,
        ModalContent,
    },
    props:      {
        image: {
            type:     Object,
            required: true,
        }
    },

    mounted() {
        this.$refs.form.setValues(this.image);
    },
    methods: {
        onSubmit(data) {
            this.$store.dispatch('media/updateImage', {...data, id: this.image.id})
                .then(() => this.$emit('close'))
                .catch((message) => this.$dmv.notifyError(message));
        },
    }
}
</script>
